module.exports = __webpack_public_path__ + "img/gameshow1.eead45af.svg";